import {
  index,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
} from "drizzle-orm/pg-core";
import { nanoid } from "nanoid";
import { user } from "./auth";
import { branches } from "./branches";

export const devicePushTokens = pgTable(
  "device_push_tokens",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    userId: text("user_id")
      .notNull()
      .references(() => user.id, { onDelete: "cascade" }),
    expoPushToken: text("expo_push_token"),
    fcmToken: text("fcm_token"),
    platform: text("platform", {
      enum: ["ios", "android", "web"],
    }).notNull(),
    appKind: text("app_kind", {
      enum: ["pos", "customer"],
    }).notNull(),
    branchId: text("branch_id").references(() => branches.id, {
      onDelete: "set null",
    }),
    lastSeenAt: timestamp("last_seen_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    uniqueIndex("device_push_tokens_expo_token_unique").on(t.expoPushToken),
    uniqueIndex("device_push_tokens_fcm_token_unique").on(t.fcmToken),
    index("device_push_tokens_user_app_kind_idx").on(t.userId, t.appKind),
    index("device_push_tokens_branch_app_kind_idx").on(t.branchId, t.appKind),
  ],
);
